(function ($) {
    $(function () {

        if (typeof objectFitImages === 'function') {
            objectFitImages();
        }

        var mnrhGroups = {};

        $('[data-match-no-row-height]').each(function () {
            var element = $(this),
                groupId = element.attr('data-match-no-row-height');

            if (groupId in mnrhGroups) {
                mnrhGroups[groupId] = mnrhGroups[groupId].add(element);
            } else {
                mnrhGroups[groupId] = element;
            }
        });

        // Apply matchHeight
        $.each(mnrhGroups, function () {
            this.matchHeight({
                byRow: true,
                property: 'min-height',
            });
        });






        var targetNode = $('.mepr_price_cell');
        console.log(targetNode);

        if (targetNode.length) {
            var observer = new MutationObserver(function (mutationsList, observer) {
                for (var mutation of mutationsList) {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {

                        var priceText = targetNode.text();
                        $('.js-price').html(`<p class="has--coupon">${priceText.replace(/(\/.*)/g, '<small class="postfix">$1</small>')}</p>`);


                    }
                }
            });

            var config = { childList: true, subtree: true, characterData: true };

            observer.observe(targetNode[0], config);
        }



        function modifyLabelWithLink() {
            var label = $('label[for="mepr_agree_to_tos1"]');
            if (label) {
                var link = label.find('a');
                var linkText = link.text();

                if (linkText.includes('I accept Quantigence')) {
                    var modifiedHTML = 'I accept Quantigence' + link[0].outerHTML.replace('I accept Quantigence', '');
                } else if (linkText.includes('I have read and agree to the')) {
                    var modifiedHTML = 'I have read and agree to the' + link[0].outerHTML.replace('I have read and agree to the', '');
                } else {
                    var modifiedHTML = 'I accept Quantigence' + link[0].outerHTML.replace('I accept Quantigence', '');
                }

                modifiedHTML = modifiedHTML.replace('<a', '<a style="font-weight: 700;"');
                label.html(modifiedHTML);
            }
        }

        if ($('.js-template-registration').length) {
            modifyLabelWithLink();
        }

        $('.js-do-search').on('click', function (e) {
            var searchQuery = $('.js-search-input').val();
            if ($('.js-search-input').outerWidth() != '56') {
                if (searchQuery != '') {
                    e.preventDefault();
                    $('.js-search-form').trigger('submit');
                }
            }
        })


        $('.js-search-input').on('focus', function () {
            var currentTerm = $.getUrlParameter('s');
            $(this).addClass('focused');
            if (currentTerm != undefined) {
                $(this).val(currentTerm);
            }
        });



        $('.js-do-search-mod').on('click', function (e) {
            var searchQuery = $('.js-search-input-mod').val();
            if (searchQuery != '') {
                e.preventDefault();
                $('.js-search-form-mod').trigger('submit');
            }
        })

        function setHeaderSticked() {
            var element = document.querySelector('.js-header');

            if (window.pageYOffset > 0) {
                element.classList.add('sticked');
            } else {
                element.classList.remove('sticked');
            }
        }

        setHeaderSticked();
        window.addEventListener('scroll', setHeaderSticked);

        if ($('.js-toc').length) {
            var tocItems = $('.toc a');

            // Create an Intersection Observer
            var observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    // Get the target heading ID from the entry's target element
                    var targetId = $(entry.target).attr('id');

                    // Find the corresponding TOC item based on the target heading ID
                    var tocItem = tocItems.filter('[href="#' + targetId + '"]');

                    // Toggle the active class based on the intersection
                    tocItem.toggleClass('active', entry.isIntersecting);
                });
            }, { threshold: 0.5 }); // Adjust the threshold as needed

            // Observe each heading with the "toc-heading" class
            $('.js-toc-heading').each(function () {
                observer.observe(this);
            });


            const $tocOpener = $('.js-open-toc');

            function isPageScrolledToBottom() {
                const scrollPosition = $(window).scrollTop();
                const windowHeight = $(window).height();
                const documentHeight = $(document).height();
                return scrollPosition + windowHeight >= documentHeight;
            }

            function handleScroll() {
                if (isPageScrolledToBottom()) {
                    $tocOpener.fadeOut();
                } else {
                    $tocOpener.fadeIn();
                }
            }

            $(window).scroll(handleScroll);
        }



        const tocMobile = document.querySelector(".js-toc-mobile");
        $('.js-open-toc').on('click', function (e) {
            e.preventDefault();
            if (window.innerWidth < 992) {
                $(this).toggleClass('open');
                $('.js-toc-mobile').slideToggle();
                if ($(this).hasClass('open')) {
                    $('.js-toc-underlay').fadeIn();
                    bodyScrollLock.disableBodyScroll(tocMobile);
                } else {
                    $('.js-toc-underlay').fadeOut();
                    bodyScrollLock.enableBodyScroll(tocMobile);
                }
            }

        })


        $('.js-toc-underlay').on('click', function (e) {
            e.preventDefault();
            $('.js-open-toc').trigger('click');
        })

        $('.js-toc-item').on('click', function (e) {
            if (window.innerWidth < 992) {
                $('.js-open-toc').removeClass('open');
                $('.js-toc-mobile').slideUp();
                $('.js-toc-underlay').fadeOut();
                bodyScrollLock.enableBodyScroll(tocMobile);
            }

        });

        if ($('.js-open-team-description').length) {
            $(document).on('click', '.js-open-team-description', function (e) {
                e.preventDefault();
                var id = $(this).data('id');
                Fancybox.show([{
                    src: `#${id}`,
                    type: "inline",
                    closeButton: false,
                    hideScrollbar: true
                }]);
            });
        }

        if ($('.js-sidebar-main-content').length) {
            $('.js-sidebar').stickySidebar({
                topSpacing: parseInt(jQuery('.js-header').outerHeight() + 40),
                containerSelector: '.js-sidebar-main-content',
                innerWrapperSelector: '.js-sidebar-inner',
                resizeSensor: false,
                minWidth: 992
            });
        }


        $('.js-show-more-benefit').on('click', function (e) {
            e.preventDefault();
            var parent = $(this).parent();
            $(this).toggleClass('active');
            parent.find('.js-hidden-benefits').slideToggle();
        })


        if ($('.js-custom-select').length) {
            $('.js-custom-select').SumoSelect();
        }


        if ($('.js-custom-select-w-search').length) {
            $('.js-custom-select-w-search').SumoSelect({
                search: true
            });
        }


        if ($('.js-custom-select-state-w-search').length) {
            $('.js-custom-select-state-w-search').SumoSelect({
                search: true
            });

            if ($('.mepr-states-text').css('display') == "none") {
                $('.js-custom-select-state-w-search').show();
            }

            var selectObserver = new MutationObserver(initSelect);

            selectObserver.observe(document.querySelector('.js-custom-select-state-w-search'), {
                childList: true,
                subtree: true,
                attributes: false,
                characterData: false
            });

            function initSelect(e) {
                $('.js-custom-select-state-w-search').hide();
                $('.js-custom-select-state-w-search')[0].sumo.reload();
                if ($('select.js-custom-select-state-w-search').children().length) {
                    $('.js-custom-select-state-w-search').show();
                }

            }
        }

        const mobilMenu = document.querySelector(".js-mobile-menu");

        $('.js-hamburger').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $('.js-header').toggleClass('active');
            $('.js-mobile-menu').toggle();
            if ($(this).hasClass('open')) {
                $('.js-menu-underlay').fadeIn();
                bodyScrollLock.disableBodyScroll(mobilMenu);

            } else {
                $('.js-menu-underlay').fadeOut();
                bodyScrollLock.enableBodyScroll(mobilMenu);
            }

        });

        $('.js-scroll-up').on('click', function (e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        })

        $('.js-menu-underlay').on('click', function (e) {
            e.preventDefault();
            $('.js-hamburger').trigger('click');
        })


        $(".js-toggle-monthly").click(function (e) {
            e.preventDefault();
            $(".content-monthly").slideToggle("slow");
        });

        $(".js-toggle-yearly").click(function (e) {
            e.preventDefault();
            $(".content-yearly").slideToggle("slow");
        });


        /* Premium Content */
        if ($('.js-template-premium-content').length) {



            $('.js-navigation-item').on('click', function (e) {
                e.preventDefault();
                var current_id = $(this).data('id');
                $('.js-navigations').find('.js-navigation-item.active').removeClass('active');
                $(this).addClass('active');
                // Fade out the active element
                $('.js-premium-content.active').fadeOut('fast', function () {

                    $(this).removeClass('active');

                    $(`#${current_id}`).fadeIn('fast', function (e) {

                        $(`#${current_id}`).addClass('active');
                    });
                });

                $.updateQueryString('type', current_id);
            });


            if ($('.js-navigation-item.active').length) {
                $('.js-navigation-item.active').get(0).scrollIntoView(false);
            }



        }


    });
})(jQuery);

// Scroll part
/* window.addEventListener('DOMContentLoaded', () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const id = entry.target.getAttribute('id');
            if (entry.intersectionRatio > 0) {
                document
                    .querySelector(`ul li a[href="#${id}"]`)
                    .parentElement.classList.add('active');
            } else {
                document
                    .querySelector(`ul li a[href="#${id}"]`)
                    .parentElement.classList.remove('active');
            }
        });
    });

    // Track all h3 that have an `id` applied
    document.querySelectorAll('h2[id]').forEach((h3) => {
        observer.observe(h3);
    });
});
 */